import React, { useEffect, useRef } from 'react';
import { Dropdown } from 'react-bootstrap';

interface ContextMenuProps {
    x: number;
    y: number;
    onClose: () => void;
    onRename: () => void;
    onDelete: () => void;  // Keep this as no arguments
    visible: boolean;
    itemType: 'folder' | 'file';  // Make itemType required
}

const ContextMenu: React.FC<ContextMenuProps> = ({
                                                     x,
                                                     y,
                                                     onClose,
                                                     onRename,
                                                     onDelete,
                                                     visible,
                                                     itemType
                                                 }) => {
    const menuRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
                onClose();
            }
        };

        if (visible) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [visible, onClose]);

    if (!visible) return null;

    return (
        <div
            ref={menuRef}
            className="position-fixed bg-white border rounded shadow"
            style={{
                top: `${y}px`,
                left: `${x}px`,
                zIndex: 1000,
                minWidth: '160px'
            }}
        >
            <Dropdown.Menu show className="position-static">
                <Dropdown.Item onClick={onRename}>
                    Rename {itemType === 'folder' ? 'Folder' : 'File'}
                </Dropdown.Item>
                <Dropdown.Divider />
                <Dropdown.Item
                    onClick={onDelete}
                    className="text-danger"
                >
                    Delete {itemType === 'folder' ? 'Folder' : 'File'}
                </Dropdown.Item>
            </Dropdown.Menu>
        </div>
    );
};

export default ContextMenu;